import { useEffect } from "react";
import { ACCOUNT_FEATURES_UPDATED_EVENT } from "../utils/account-features-events";

/**
 * Re-run `refresh` when feature toggles are saved for the same account.
 * @param {string|number|null|undefined} accountId
 * @param {() => void|Promise<void>} refresh
 */
export function useRefreshOnAccountFeaturesUpdated(accountId, refresh) {
  useEffect(() => {
    if (!accountId || typeof window === "undefined" || typeof refresh !== "function") {
      return undefined;
    }
    const onUpdated = (event) => {
      const updatedId = event?.detail?.accountId;
      if (updatedId != null && String(updatedId) !== String(accountId)) {
        return;
      }
      refresh();
    };
    window.addEventListener(ACCOUNT_FEATURES_UPDATED_EVENT, onUpdated);
    return () => window.removeEventListener(ACCOUNT_FEATURES_UPDATED_EVENT, onUpdated);
  }, [accountId, refresh]);
}
